import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

// Plain form controls in the neon look. Native elements keep them accessible and
// keyboard-friendly without extra libraries.

const control =
  'w-full bg-bg-3/80 px-2.5 py-1.5 text-sm text-text shadow-[inset_0_0_0_1px_var(--color-line)] outline-none placeholder:text-dim focus:shadow-[inset_0_0_0_1px_var(--color-cyan)] disabled:opacity-50';

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return <input className={cn(control, className)} {...props} />;
}

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(control, 'min-h-24 resize-y font-mono text-[13px] leading-relaxed', className)}
      {...props}
    />
  );
}

export function Select({ className, ...props }: ComponentProps<'select'>) {
  return <select className={cn(control, 'cursor-pointer pr-6', className)} {...props} />;
}

/** A small caps label above a control. */
export function Field({
  label,
  className,
  children,
}: {
  label: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <label className={cn('flex flex-col gap-1', className)}>
      <span className="font-display text-[9px] font-bold tracking-[0.18em] text-muted uppercase">{label}</span>
      {children}
    </label>
  );
}
